import React from 'react'
import {Link} from 'react-router-dom'

export default class HeaderTopImage extends React.Component {
	render() {
		return (
			<>
		<div className='container-fluid' style={{paddingRight:'0',paddingLeft:'0', marginTop:'-1em'}}>
        <div className='bgImage' style={{position: 'relative', height:'325px', backgroundImage: `url("https://www.grospick.com/img/logo_img/aboutt.png")`, boxShadow: '0 3px 5px rgba(0, 0, 0, 0.2)', backgroundSize: 'cover', backgroundPosition: 'center',resize: 'both',borderBottom:'1px solid #00000010',paddingBottom:'10px', marginBottom:0}}> 
<div className="header-adress-yo" style={{
	position: 'relative',
    height: '270px',
    padding:0,
    top:0,
    background: 'linear-gradient(rgba(0, 0, 0, 0.52) 100%, rgba(0, 0, 0, 0) 100%)',
    textAlign: 'center',
    color: '#ffffff',
    zIndex: '20'
}}>
<h1 style={{
    color: 'floralwhite',
    margin: 0,
    position: 'absolute',
    fontSize:'36px',
    textShadow: '#212922 3px 0 4px',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -40%)'
   }}>
    {this.props.titre}</h1>
</div>
<div className="container-fluid" style={{position:'absolute', top:'130px'}}>
              <div className="row" id='shiftRight' style={{marginTop:'32px'}}>
                
            </div>      
</div></div>
</div>
			<div className="page-top-info" style={{paddingBottom:'-220px',padding: '20px 0 2px'}}>
		<div className="container">
			<div className="site-pagination" style={{textAlign:'left'}}>
		<Link to="/">{this.props.destination}</Link> >> <a href="" style={{fontWeight:300}}>{this.props.titre}</a>
			</div></div>
	</div>
	</>
		)
	}
}